import { render } from "./GroupProfiles.vue?vue&type=template&id=4386edf6&scoped=true"
import script from "./GroupProfiles.vue?vue&type=script&lang=js"
export * from "./GroupProfiles.vue?vue&type=script&lang=js"

import "./GroupProfiles.vue?vue&type=style&index=0&id=4386edf6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4386edf6"]])

export default __exports__